<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.paymentOption.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.paymentOption.list.title"></app-i18n>
      </h1>

      <app-payment-option-list-toolbar></app-payment-option-list-toolbar>
      <app-payment-option-list-filter></app-payment-option-list-filter>
      <app-payment-option-list-table></app-payment-option-list-table>
    </div>
  </div>
</template>

<script>
import PaymentOptionListFilter from '@modules/payment-option/components/payment-option-list-filter.vue';
import PaymentOptionListTable from '@modules/payment-option/components/payment-option-list-table.vue';
import PaymentOptionListToolbar from '@modules/payment-option/components/payment-option-list-toolbar.vue';

export default {
  name: 'app-payment-option-list-page',

  components: {
    [PaymentOptionListFilter.name]: PaymentOptionListFilter,
    [PaymentOptionListTable.name]: PaymentOptionListTable,
    [PaymentOptionListToolbar.name]: PaymentOptionListToolbar,
  },
};
</script>

<style>
</style>
